import '/app/brewery-packages/content/content-editor-plugin-ordered-list/src/OrderedList.css-raw';
export default {
  "orderedList": "employees-21b62107-orderedList-Gei3fa"
};